// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:57:54

export default {
  "id": "falling-blocks-puzzle",
  "slug": "falling-blocks-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d1a3ec041f214fd193f9191171b56e5e-200x120.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d1a3ec041f214fd193f9191171b56e5e/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Falling Blocks Puzzle",
      "description": "Jewel Block Challenges is a timeless puzzle game where players arrange falling geometric shapes, to form complete horizontal lines. As lines are completed, they disappear, and players earn points. The game ends when the stack of shapes reaches the top of the screen. It’s a test of strategy and quick thinking, beloved by gamers worldwide.",
      "instructions": "Keyboard:\n⚈ Left arrow: Move left\n⚈ Right arrow: Move right\n⚈ Dow arrow: Move down\n⚈ Up arrow or X: Rotate right\n⚈ Z: Rotate left\n⚈ Space : Drop\n⚈ Left arrow: Move left\n\nMouse or touch:\n⚈ Left mouse click (or touch): Rotate\n⚈ Left mouse drag (or touch drag): Move\n⚈ Drop button: Drop",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "block",
        "classic",
        "crystal",
        "tetris"
      ]
    },
    "zh-CN": {
      "title": "下落方块谜题",
      "description": "宝石方块挑战是一款永恒的益智游戏，玩家需要排列下落的几何形状，形成完整的水平线。完成线条后，它们会消失，玩家获得积分。当形状堆叠到达屏幕顶部时，游戏结束。这是一场策略和快速思考的考验，深受全球玩家喜爱。",
      "instructions": "键盘：\n⚈ 左箭头：向左移动\n⚈ 右箭头：向右移动\n⚈ 下箭头：向下移动\n⚈ 上箭头或X：向右旋转\n⚈ Z：向左旋转\n⚈ 空格：下落\n⚈ 左箭头：向左移动\n\n鼠标或触摸：\n⚈ 左键点击（或触摸）：旋转\n⚈ 左键拖动（或触摸拖动）：移动\n⚈ 放下按钮：下落",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "街机",
        "方块",
        "经典",
        "水晶",
        "俄罗斯方块"
      ]
    },
    "zh-TW": {
      "title": "墜落方塊拼圖",
      "description": "寶石塊挑戰是一款經典的益智遊戲，玩家需要排列下落的幾何形狀，形成完整的水平線。當線條完成時，它們會消失，玩家會獲得分數。遊戲結束於形狀堆疊達到螢幕頂部時。這是一場策略和快速思考的考驗，深受全球遊戲玩家喜愛。",
      "instructions": "鍵盤：\n⚈ 左箭頭：向左移動\n⚈ 右箭頭：向右移動\n⚈ 下箭頭：向下移動\n⚈ 上箭頭或 X：向右旋轉\n⚈ Z：向左旋轉\n⚈ 空白鍵：落下\n⚈ 左箭頭：向左移動\n\n滑鼠或觸控：\n⚈ 左滑鼠點擊（或觸控）：旋轉\n⚈ 左滑鼠拖曳（或觸控拖曳）：移動\n⚈ 放下按鈕：落下",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "電玩",
        "塊",
        "經典",
        "水晶",
        "俄罗斯方块"
      ]
    },
    "zh-HK": {
      "title": "墮落方塊謎題",
      "description": "寶石塊挑戰是一個不朽的拼圖遊戲，玩家需排列下落的幾何形狀，以形成完整的水平線。完成線後，它們會消失，玩家獲得分數。遊戲在形狀堆疊到屏幕頂部時結束。這是一項策略和快速思考的考驗，受到全世界的遊戲玩家喜愛。",
      "instructions": "键盘：\n⚈ 左箭頭：向左移動\n⚈ 右箭頭：向右移動\n⚈ 下箭頭：向下移動\n⚈ 上箭頭或 X：向右旋轉\n⚈ Z：向左旋轉\n⚈ 空白鍵：落下\n⚈ 左箭頭：向左移動\n\n滑鼠或觸控：\n⚈ 左鍵點擊（或觸控）：旋轉\n⚈ 左鍵拖曳（或觸控拖曳）：移動\n⚈ 放下按鈕：落下",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "電玩",
        "方塊",
        "經典",
        "水晶",
        "俄羅斯方塊"
      ]
    },
    "ja": {
      "title": "落下ブロックパズル",
      "description": "ジェルブロックチャレンジは、永遠のパズルゲームで、プレイヤーは落ちてくる幾何形状を並べて、水平線を完成させます。ラインが完成すると、それが消え、プレイヤーはポイントを獲得します。ゲームは、形状の山がスクリーンの最上部に達したときに終了します。これは、戦略と素早い思考の試練であり、世界中のゲーマーに親しまれています。",
      "instructions": "キーボード：\n⚈ 左矢印：左に移動\n⚈ 右矢印：右に移動\n⚈ 下矢印：下に移動\n⚈ 上矢印またはX：右回転\n⚈ Z：左回転\n⚈ スペース：落下\n⚈ 左矢印：左に移動\n\nマウスまたはタッチ：\n⚈ 左マウスクリック（またはタッチ）：回転\n⚈ 左マウスドラッグ（またはタッチドラッグ）：移動\n⚈ ドロップボタン：落下",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "アーケード",
        "ブロック",
        "クラシック",
        "クリスタル",
        "テトリス"
      ]
    },
    "ko": {
      "title": "빌딩 블록 퍼즐",
      "description": "정취 블록 챌린지는 시간이 지나도 변하지 않는 패ズル 게임으로, 플레이어는 떨어지는了几何학적 형태를 정렬하여 완전한 수평선을 형성합니다. 선이 완성되면 사라지고, 플레이어는 점수를 얻습니다. 형태의 쌓임이 화면의 상단에 도달하면 게임이 끝납니다. 전략과 빠른 사고력을 테스트하는 게임으로, 전 세계의 게이머들에게 사랑받고 있습니다.",
      "instructions": "키보드:\n⚈ 왼쪽 방향키: 왼쪽으로 이동\n⚈ 오른쪽 방향키: 오른쪽으로 이동\n⚈ 아래 방향키: 아래로 이동\n⚈ 위 방향키 또는 X: 오른쪽 회전\n⚈ Z: 왼쪽 회전\n⚈ 공백키: 내려놓기\n⚈ 왼쪽 방향키: 왼쪽으로 이동\n\n마우스 또는 터치:\n⚈ 왼쪽 마우스 클릭(또는 터치): 회전\n⚈ 왼쪽 마우스 드래그(또는 터치 드래그): 이동\n⚈ 드롭 버튼: 내려놓기",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "아케이드",
        "블록",
        "클래식",
        "크리스탈",
        "테트리스"
      ]
    },
    "fr": {
      "title": "Puzzle de blocs tombants",
      "description": "Jewel Block Challenges est un jeu de puzzle intemporel où les joueurs organisent des formes géométriques tombantes pour former des lignes horizontales complètes. Lorsque les lignes sont complétées, elles disparaissent et les joueurs gagnent des points. Le jeu se termine lorsque le tas de formes atteint le sommet de l'écran. C'est un test de stratégie et de rapidité, aimé par les joueurs du monde entier.",
      "instructions": "Clavier :\n⚈ Flèche de gauche : Déplacer vers la gauche\n⚈ Flèche de droite : Déplacer vers la droite\n⚈ Flèche du bas : Déplacer vers le bas\n⚈ Flèche du haut ou X : Rotation à droite\n⚈ Z : Rotation à gauche\n⚈ Espace : Lâcher\n⚈ Flèche de gauche : Déplacer vers la gauche\n\nSouris ou tactile :\n⚈ Clic gauche de la souris (ou tactile) : Rotation\n⚈ Glisser avec la souris (ou glisser tactile) : Déplacement\n⚈ Bouton de lâcher : Lâcher",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "bloc",
        "classique",
        "cristal",
        "tétris"
      ]
    }
  }
};
